import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {BadgeAnchor as RmwcBadgeAnchor} from '@rmwc/badge'
import '@rmwc/badge/styles'

export const StyledRmwcBadgeAnchor = styled(RmwcBadgeAnchor)``

const BadgeAnchor = ({children, ...otherProps}) => <RmwcBadgeAnchor {...otherProps}>{children}</RmwcBadgeAnchor>

BadgeAnchor.propTypes = {
  children: PropTypes.any
}

export {BadgeAnchor}
